export const API_URL = process.env.REACT_APP_API_URL ?? ''; //Edit this to your API URL's path here. However, It is recommended to store your API's URL to .env file.

export const URL_IMAGE = process.env.REACT_APP_API_URL_IMAGE ?? '';

export const URL_FE = process.env.REACT_APP_API_URL_FE ?? 'http://localhost:3000';

export const API_URL_RECAPTCHA = process.env.REACT_APP_API_URL_RECAPTCHA || '';
